import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const itemWrapper: SxStyle = {
  background: (p) => p.palette.common.white,
};

export const Scrollbar: SxStyle = {
  height: (p) => p.spacing(55),
};

export const text1: SxStyle = {
  color: (p) => p.palette.grey[700],
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const text2: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightLight,
  width: (p) => p.spacing(25),
};

export const notFound: SxStyle = {
  padding: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
  border: (p) => `1px solid ${p.palette.grey[300]}`,
  borderRadius: (p) => p.spacing(0.5),
};

export const box: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: (p) => p.palette.common.white,
};
